<template>
	<div class="container">
		<div
			v-for="item in props.data"
			:key="item.hot_ranking_category_pk"
			class="container_item cursor-pointer"
			@click="onClickHotRankingCard(item.hot_ranking_pk, item.hot_ranking_category_pk)"
		>
			<div class="container_item_image">
				<img :src="item.hot_ranking_image_path" alt="hot_ranking_image" loading="lazy" />
			</div>
			<span>{{ item.hot_ranking_name }}</span>
		</div>
	</div>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router';

import { HotRankingCategory } from '@/api/home';
import { useHeaderStore } from '@/stores/header';

const props = defineProps<{
	data: HotRankingCategory[];
}>();

const router = useRouter();
const headerStore = useHeaderStore();

const onClickHotRankingCard = (pk: number, categoryPk: number) => {
	const country = headerStore.getCountry;
	if (country === 'JPN') {
		router.push(`/hot-ranking-detail/jpn/${pk}/${categoryPk}`);
	} else if (country === 'USA') {
		router.push(`/hot-ranking-detail/usa/${pk}/${categoryPk}`);
	} else if (country === 'KR') {
		router.push(`/hot-ranking-detail/kr/${pk}/${categoryPk}`);
	}
};
</script>

<style lang="scss" scoped>
.container {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	&_item {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 1rem;
		padding: 1.6rem;
		span {
			font-size: var(--font-s-mid);
			font-weight: var(--font-w-semi-bold);
			line-height: 1.79rem;
			text-align: center;
		}
		&_image {
			max-width: 6rem;
			height: 6rem;
			width: 100%;
			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
	}
}
</style>
